module.exports = __webpack_public_path__ + "images/emoji/clock530.9215845a612ebdcdc9fe.png";